document.addEventListener('alpine:init', () => {
  Alpine.data('ProductCardSlider', () => ({
    init() {
      if (typeof Splide === 'undefined') {
        console.error('Splide not loaded!');
        return;
      }

      const splide = new Splide(this.$root, {
        type: 'loop', // "slide, loop"
        perPage: 1,
        arrows: true,
        pagination: true,
        autoplay: false,
        lazyLoad: 'nearby', // just load next 1 image
      }).mount();

      this.$root.classList.remove('opacity-0');
      this.$root.parentElement.querySelector('.product-card-first-image').classList.remove('opacity-0');
      this.$root.closest('.product-card').setAttribute('data-slider-loaded', '');

      if (window.matchMedia && window.matchMedia('(hover: hover)').matches) {
        this.$root.addEventListener('mouseenter', () => {
          splide.options = { speed: 1 };
          splide.go(1);
          splide.options = { speed: 400 };
        });
      }
    }
  }));
});